import React from "react"
import { ListItemElement, SubItem } from "./elements"


const ListItem = (props) => {
  return (
    props.subitem ? 
      <SubItem>
        <p>{props.title}</p>
      </SubItem>
      :
      <ListItemElement compact={props.compact}>
        <p>{props.title}</p>
      </ListItemElement>
  )
}

export default ListItem
